import { Button } from "react-bootstrap";
import { useAppContext } from "../../../appContext/AppContext";
import TableTemplate from "../../../component/table-pagination";
import { asyncWrapper } from "../../../utils/AppFunction";
import { MEDICAL_RECORD_SYSTEM } from "../../../utils/Constant";
import { MEDICAL_RECORD_COLUMNS } from "../../constants/columns";
import { getMedicalRecordLink } from "../../services/PatientServices";

type Props = {
	data: any[];
};

const MedicalRecordList = ({ data }: Props) => {
	const { setIsLoading } = useAppContext();

	const onActionButtonClick = (row: any, actionType: string) => {
		viewMedicalRecord(row);
	};

	const viewMedicalRecord = async (row: any) => {
		const [data] = await asyncWrapper(
			getMedicalRecordLink({
				medicalRecordCode: row.medicalRecordCode,
				system: MEDICAL_RECORD_SYSTEM.ELSAGA,
			}),
			setIsLoading,
		);

		if (!data) return;

		window.open(data, "_blank");
	};

	return (
		<div>
			<div className="d-flex justify-content-between align-items-center mb-3">
				<h3 className="text-info mb-0 fs-5">Bệnh án điện tử</h3>
				<Button className="btn-fill">Thêm mới</Button>
			</div>

			<TableTemplate
				data={data ?? []}
				columns={MEDICAL_RECORD_COLUMNS}
				selectable={false}
				tableClassname="h-200"
				tableOptions={{
					onActionButtonClick,
				}}
			/>
		</div>
	);
};

export default MedicalRecordList;
